// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"d60a98aa","119":"be7abc5c","144":"7240b37b","361":"d18a152d","405":"24777fd5","426":"45a27aaf","506":"b9236480","562":"056df6d6","701":"a55dcf01","726":"01b220a8","734":"57f49c82"}[chunkId] + ".chunk.js";
};